<script>
import TurnIndicator from './TurnIndicator.vue'

export default {
    components: {
        TurnIndicator,
    },
    props: {
        profile: {
            type: Object,
            required: true,
        },
        color: {
            type: String,
            required: true,
        },
    },
}
</script>

<template>
    <div class="killerBg absolute z-20 h-full w-full bg-black">
        <div
            class="flex h-full w-full items-center justify-center bg-[url('@/assets/images/games/killer/turnPattern.svg')] bg-size-[auto_100%] bg-center"
        >
            <TurnIndicator :currentPlayer="profile" :profileColor="color" />
        </div>
    </div>
</template>
